import { Box, Heading, List, ListItem } from "@biblioteksentralen/react";
import { slugifyString, sortArrayInGroups } from "@biblioteksentralen/utils";
import { AppealTerm } from "@libry-content/integrations";
import { SubjectBadge } from "../../searchAndCollection/components/works/SubjectBadge";
import InternalLink from "../InternalLink";
import { useCommonData } from "../layout/CommonDataProvider";

interface Props {
  appealTerms: AppealTerm[];
}

const AppealTerms = ({ appealTerms }: Props) => {
  // Viser opptil sju termer. Viser alltid de fire viktigste termene, pluss de som har mer enn 0.5 i gjennomsnittsvekt
  const relevantTerms = appealTerms.filter((term, i) => (i < 4 || term.averageWeight > 0.5) && i < 7);

  const searchIntegrationEnabled = useCommonData().site?.librarySystem?.searchIntegration !== "disabled";

  const termsByFactor = sortArrayInGroups(relevantTerms, (term) => term.term.factor.label)
    // Sorterer faktorer alfabetisk så rekkefølgen er stabil mellom anbefalinger
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  return (
    <List spacing={4}>
      {termsByFactor.map((factor) => (
        <ListItem key={factor.label} display="flex" flexDirection={{ base: "column", md: "row" }}>
          <Heading as="h3" size="sm" alignSelf={{ md: "center" }} fontWeight="normal" minW="10rem">
            {factor.label}
          </Heading>
          <List display="flex" flexWrap="wrap" gridGap=".5rem" whiteSpace="nowrap">
            {factor.items.map((term) => (
              <ListItem key={term.term.id}>
                {searchIntegrationEnabled ? (
                  <SubjectBadge as={InternalLink} href={getAppealTermPath(term.term.id, term.term.label)}>
                    {term.term.label}
                  </SubjectBadge>
                ) : (
                  <SubjectBadge
                    as={Box}
                    // tomt hoverobject for å skru av hovereffekten
                    _hover={{}}
                  >
                    {term.term.label}
                  </SubjectBadge>
                )}
              </ListItem>
            ))}
          </List>
        </ListItem>
      ))}
    </List>
  );
};

const getAppealTermPath = (id: string, label: string) => `/samling/appellfaktor/${slugifyString(label)}_${id}`;

export default AppealTerms;
